<template>
  <service-category>

    <layout-header-title slot="header" title="시스템 설정"/>

    <div class="category" slot="category">

      <layout-two-column title="안드로이드 최소 버전">

        <layout-input v-model="editable.androidMinVersion"
                      placeHolder="안드로이드 최소 버전을 입력해주세요."
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <layout-two-column title="안드로이드 현재 버전">

        <layout-input v-model="editable.androidCurrentVersion"
                      placeHolder="안드로이드 현재 버전을 입력해주세요."
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <layout-two-column title="IOS 최소 버전">

        <layout-input v-model="editable.iosMinVersion"
                      placeHolder="IOS 최소 버전을 입력해주세요."
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <layout-two-column title="IOS 현재 버전">

        <layout-input v-model="editable.iosCurrentVersion"
                      placeHolder="IOS 현재 버전을 입력해주세요."
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

    </div>

  </service-category>
</template>

<script>
import { regex } from '@/utils/utils';

import LayoutHeaderTitle from '@/spa/components/LayoutHeaderTitle';
import LayoutInput from '@/spa/components/LayoutInput';

import LayoutTwoColumn from '../LayoutTwoColumn';
import ServiceCategory from '../ServiceCategory';

export default {
  name: 'SystemSetting',
  props: {
    androidMinVersion: Number,
    androidCurrentVersion: Number,
    iosMinVersion: Number,
    iosCurrentVersion: Number,
  },
  components: {
    ServiceCategory,

    LayoutTwoColumn,
    LayoutHeaderTitle,
    LayoutInput,
  },
  methods: {
    regex(min, max) {
      return regex(min, max);
    },
  },
  watch: {
    'editable.androidMinVersion': {
      deep: true,
      handler(value) {
        this.$emit('onChangeAndroidMinVersion', value);
      },
    },
    'editable.androidCurrentVersion': {
      deep: true,
      handler(value) {
        this.$emit('onChangeAndroidCurrentVersion', value);
      },
    },
    'editable.iosMinVersion': {
      deep: true,
      handler(value) {
        this.$emit('onChangeIosMinVersion', value);
      },
    },
    'editable.iosCurrentVersion': {
      deep: true,
      handler(value) {
        this.$emit('onChangeIosCurrentVersion', value);
      },
    },
  },
  data() {
    return {
      editable: {
        androidMinVersion: this.androidMinVersion,
        androidCurrentVersion: this.androidCurrentVersion,
        iosMinVersion: this.iosMinVersion,
        iosCurrentVersion: this.iosCurrentVersion,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.category {
  width: 100%;
  min-width: 540px;

  .info {
    text-align: left;
    margin-top: 6px;
    margin-left: 174px;
    font-size: 12px;
    color: #666;
  }

  .unit-text {
    display: inline-block;
    width: 40px;
    text-align: left;
    margin-left: 10px;

    padding: 0;
  }

  .input {
    width: 100%;
    min-width: 150px;
    max-width: 350px;
  }
}

@media screen and (max-width: 1024px) {
  .category {
    width: 100%;
    min-width: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    .info {
      margin-left: 0;
      width: 80%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/category/SystemSetting.vue